import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  search: {
    id: '@lib.core.Filters.search',
    defaultMessage: 'Search',
  },
  clearSelections: {
    id: '@lib.core.Filters.clearSelections',
    defaultMessage: 'Clear selections',
  },
  clearExcluded: {
    id: '@lib.core.Filters.clearExcluded',
    defaultMessage: 'Clear excluded',
  },
  all: {
    id: '@lib.core.Filters.all',
    defaultMessage: 'All',
  },
  selectAll: {
    id: '@lib.core.Filters.selectAll',
    defaultMessage: 'Select all',
  },
  appointmentStatus: {
    id: '@lib.core.Filters.appointmentStatus',
    defaultMessage: 'Appointment Status',
  },
  appointmentType: {
    id: '@lib.core.Filters.appointmentType',
    defaultMessage: 'Appointment Type',
  },
  appointmentTypeItemsLabel: {
    id: '@lib.core.Filters.appointmentType.itemsLabel',
    defaultMessage: 'Any current and future appointment types',
  },
  provider: {
    id: '@lib.core.Filters.provider',
    defaultMessage: 'Provider',
  },
  providerItemsLabel: {
    id: '@lib.core.Filters.provider.itemsLabel',
    defaultMessage: 'Any current and future providers',
  },
  facility: {
    id: '@lib.core.Filters.facility',
    defaultMessage: 'Facility',
  },
  facilityItemsLabel: {
    id: '@lib.core.Filters.facility.itemsLabel',
    defaultMessage: 'Any current and future facilities',
  },
  confirmed: {
    id: '@lib.core.Filters.AppointmentStatusFilter.Confirmed',
    defaultMessage: 'Confirmed',
  },
  unconfirmed: {
    id: '@lib.core.Filters.AppointmentStatusFilter.Unconfirmed',
    defaultMessage: 'Unconfirmed',
  },
  cancelled: {
    id: '@lib.core.Filters.AppointmentStatusFilter.Cancelled',
    defaultMessage: 'Cancelled',
  },
  cancelledNoShow: {
    id: '@lib.core.Filters.AppointmentStatusFilter.Cancelled.noShow',
    defaultMessage: 'Reason: No-show',
  },
  cancelledNone: {
    id: '@lib.core.Filters.AppointmentStatusFilter.Cancelled.none',
    defaultMessage: 'Reason: None',
  },
});
